import React from 'react';
import { User, Mail, Phone, MapPin, Home } from 'lucide-react';
interface UserDetailsProps {
  firstName: string;
  surname: string;
  farm: string;
  location?: string;
  email: string;
  phone: string;
  onUpdate: (field: string, value: string) => void;
}
export function UserDetails({
  firstName,
  surname,
  farm,
  location = '',
  email,
  phone,
  onUpdate
}: UserDetailsProps) {
  return <div className="space-y-5" data-id="element-583">
      <div className="mb-6" data-id="element-584">
        <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-585">Your Details</h3>
        <p className="text-sm text-slate-500" data-id="element-586">
          Please provide your contact information for this booking.
        </p>
      </div>

      <div className="space-y-4" data-id="element-587">
        {/* First Name */}
        <div data-id="element-588">
          <label htmlFor="firstName" className="block text-sm font-medium text-slate-700 mb-2" data-id="element-589">
            First Name *
          </label>
          <div className="relative" data-id="element-590">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-591">
              <User size={18} className="text-slate-400" data-id="element-592" />
            </div>
            <input type="text" id="firstName" value={firstName} onChange={e => onUpdate('firstName', e.target.value)} className="w-full pl-10 pr-4 py-2.5 border border-slate-300 rounded-lg focus:ring-2 focus:ring-slate-900 focus:border-transparent transition-all outline-none" placeholder="John" data-id="element-593" />
          </div>
        </div>

        {/* Surname */}
        <div data-id="element-594">
          <label htmlFor="surname" className="block text-sm font-medium text-slate-700 mb-2" data-id="element-595">
            Surname *
          </label>
          <div className="relative" data-id="element-596">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-597">
              <User size={18} className="text-slate-400" data-id="element-598" />
            </div>
            <input type="text" id="surname" value={surname} onChange={e => onUpdate('surname', e.target.value)} className="w-full pl-10 pr-4 py-2.5 border border-slate-300 rounded-lg focus:ring-2 focus:ring-slate-900 focus:border-transparent transition-all outline-none" placeholder="Smith" data-id="element-599" />
          </div>
        </div>

        {/* Farm Name */}
        <div data-id="element-600">
          <label htmlFor="farm" className="block text-sm font-medium text-slate-700 mb-2" data-id="element-601">
            Farm Name *
          </label>
          <div className="relative" data-id="element-602">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-603">
              <Home size={18} className="text-slate-400" data-id="element-604" />
            </div>
            <input type="text" id="farm" value={farm} onChange={e => onUpdate('farm', e.target.value)} className="w-full pl-10 pr-4 py-2.5 border border-slate-300 rounded-lg focus:ring-2 focus:ring-slate-900 focus:border-transparent transition-all outline-none" placeholder="Willow Creek Farm" data-id="element-605" />
          </div>
        </div>

        {/* Farm Address */}
        <div data-id="element-606">
          <label htmlFor="location" className="block text-sm font-medium text-slate-700 mb-2" data-id="element-607">
            Farm Address *
          </label>
          <div className="relative" data-id="element-608">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-609">
              <MapPin size={18} className="text-slate-400" data-id="element-610" />
            </div>
            <input type="text" id="location" value={location} onChange={e => onUpdate('location', e.target.value)} className="w-full pl-10 pr-4 py-2.5 border border-slate-300 rounded-lg focus:ring-2 focus:ring-slate-900 focus:border-transparent transition-all outline-none" placeholder="123 Farm Road, Stanthorpe QLD 4380" data-id="element-611" />
          </div>
        </div>

        {/* Email */}
        <div data-id="element-612">
          <label htmlFor="email" className="block text-sm font-medium text-slate-700 mb-2" data-id="element-613">
            Email Address *
          </label>
          <div className="relative" data-id="element-614">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-615">
              <Mail size={18} className="text-slate-400" data-id="element-616" />
            </div>
            <input type="email" id="email" value={email} onChange={e => onUpdate('email', e.target.value)} className="w-full pl-10 pr-4 py-2.5 border border-slate-300 rounded-lg focus:ring-2 focus:ring-slate-900 focus:border-transparent transition-all outline-none" placeholder="john.smith@example.com" data-id="element-617" />
          </div>
        </div>

        {/* Phone */}
        <div data-id="element-618">
          <label htmlFor="phone" className="block text-sm font-medium text-slate-700 mb-2" data-id="element-619">
            Phone Number *
          </label>
          <div className="relative" data-id="element-620">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-621">
              <Phone size={18} className="text-slate-400" data-id="element-622" />
            </div>
            <input type="tel" id="phone" value={phone} onChange={e => onUpdate('phone', e.target.value)} className="w-full pl-10 pr-4 py-2.5 border border-slate-300 rounded-lg focus:ring-2 focus:ring-slate-900 focus:border-transparent transition-all outline-none" placeholder="0412 345 678" data-id="element-623" />
          </div>
        </div>
      </div>

      <div className="bg-blue-50 border border-blue-100 rounded-lg p-4 text-sm text-blue-700 mt-6" data-id="element-624">
        <p className="font-medium" data-id="element-625">Contact Information</p>
        <p className="opacity-90 mt-1" data-id="element-626">
          We'll use these details to coordinate the pickup and keep you updated
          about your booking.
        </p>
      </div>
    </div>;
}